
<template>
	<b-tab title="DELIVERY" active>
		<h3 class="text-center d-none d-lg-block">Despacho de Unidades</h3>
		<h4 class="text-center d-lg-none text-center">Despacho de Unidades</h4>
		<p class="mt-3 text-justify">
			Compra tranquilo! Te lo dejamos en tu casa! Conoce los mejores valores de envío en nuestro tarifario a continuación
		</p>
		<b-table-simple borderless responsive class="bg-grey shadow-sm">
			<b-tr>
				<b-td colspan="2">
					<h4 class="text-center"><span class="underline-macal">Tabla de Precios</span><small>*</small></h4>
				</b-td>
			</b-tr>
			<b-tr colspan="2">
				<b-td class="text-macal text-center">
					<b>Desde Macal hacia el destino</b>
				</b-td>
			</b-tr>
			<b-tr>
				<b-td>
					<b-table-simple bordered caption-top responsive striped>
						<b-thead>
							<b-tr>
								<b-th><small><b>Origen Santiago</b></small></b-th>
								<b-th><small><b>Destino</b></small></b-th>
								<b-th><small><b>Autos - SUV / Camionetas Normales</b></small></b-th>
							</b-tr>
						</b-thead>
						<b-tbody>
							<b-tr>
								<b-td><b>RM</b></b-td>
								<b-td>Ciudad de Santiago</b-td>
								<b-td align="right">$ 48.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Zonas Urbanas RM</b-td>
								<b-td align="right">$ 83.000</b-td>
							</b-tr>
							<b-tr>
								<b-td><b>ZONA NORTE</b></b-td>
								<b-td>Arica</b-td>
								<b-td align="right">$ 750.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Iquique</b-td>
								<b-td align="right">$ 670.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Calama</b-td>
								<b-td align="right">$ 590.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Antofagasta</b-td>
								<b-td align="right">$ 550.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Copiapó</b-td>
								<b-td align="right">$ 390.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>La Serena</b-td>
								<b-td align="right">$ 260.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Coquimbo</b-td>
								<b-td align="right">$ 260.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Los Vilos</b-td>
								<b-td align="right">$ 260.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>La Ligua</b-td>
								<b-td align="right">$ 260.000</b-td>
							</b-tr>
							<b-tr>
								<b-td><b>ZONA CENTRO</b></b-td>
								<b-td>Quillota</b-td>
								<b-td align="right">$ 190.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>San Felipe</b-td>
								<b-td align="right">$ 190.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Valparaíso</b-td>
								<b-td align="right">$ 190.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Viña del mar</b-td>
								<b-td align="right">$ 190.000</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</b-td>
				<b-td>
					<b-table-simple bordered caption-top responsive striped>
						<b-thead>
							<b-tr>
								<b-th><small><b>Origen Santiago</b></small></b-th>
								<b-th><small><b>Destino</b></small></b-th>
								<b-th><small><b>Autos - SUV / Camionetas Normales</b></small></b-th>
							</b-tr>
						</b-thead>
						<b-tbody>
							<b-tr>
								<b-td><b>ZONA SUR</b></b-td>
								<b-td>Rancagua</b-td>
								<b-td align="right">$ 180.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Curicó</b-td>
								<b-td align="right">$ 210.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Talca</b-td>
								<b-td align="right">$ 230.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Linares</b-td>
								<b-td align="right">$ 250.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Chillán</b-td>
								<b-td align="right">$ 250.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Los Ángeles</b-td>
								<b-td align="right">$ 280.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Concepción</b-td>
								<b-td align="right">$ 280.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Collipulli</b-td>
								<b-td align="right">$ 320.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Ercilla</b-td>
								<b-td align="right">$ 320.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Temuco</b-td>
								<b-td align="right">$ 320.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Valdivia</b-td>
								<b-td align="right">$ 400.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Osorno</b-td>
								<b-td align="right">$ 420.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Frutillar</b-td>
								<b-td align="right">$ 450.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Puerto Varas</b-td>
								<b-td align="right">$ 450.000</b-td>
							</b-tr>
							<b-tr>
								<b-td></b-td>
								<b-td>Puerto Montt</b-td>
								<b-td align="right">$ 450.000</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</b-td>
			</b-tr>
			<b-tr>
				<b-td class="text-center" colspan="2">
					<router-link :to="{ name: 'vehicles-transfer', params: {car_id: car_id} }"  size="lg" class="mt-3 pl-5 pr-5 btn btn-macal" variant="macal">SOLICITAR AHORA</router-link>
				</b-td>
			</b-tr>
		</b-table-simple>
		<div class="text-right"><small>*Entrega en domicilio sólo Zonas Urbanas</small></div>
		<div class="text-right"><small>*Todos los valores incluyen IVA</small></div>
	</b-tab>
</template>

<script>
	export default {
		name: 'v-tab-transfer',
		props: {
			car_id: {default: null},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>